import { Table, Body, Head, Row, Th, Td, Paginator, NoDataComponent } from "../Tables/Table"
import { FC } from "react"
import { BoxWrapper } from "../Wrappers/Wrappers";
import { LoadingTableCell } from "../Loading/Loading";
import { DetailText, Text } from "../units/Text";
import { AxiosDeleteOrganization } from "../../components/Rest/RestStaffOrganization";
import { OrderController } from "../Tables/Table";
import { AxiosResponseProps, Params } from "../../components/Rest/RestStaffOrganization"
import { RestApiState } from "../Rest/Organization";
import { Loader } from "../units/Loader";
import Alert from "../units/Alerts";
import { OrganizationProps } from "../../components/Rest/RestStaffOrganization";
import { useState } from "react";
import { FlexWrapper } from "../Wrappers/Wrappers";

const tableNoData = 'Нет данных'


interface AcbTableProps {
    data: AxiosResponseProps | undefined;
    currentPage: number;
    itemsPerPage: number;
    params: Params;
    setter: (value: number) => void;
    orderSetter: (value: string) => void;
    deleteHook: (value:RestApiState) => void
}

interface OrgDeleteProps {
    id : number;
    organization_name: string;
}

export const OrganizationTable:FC<AcbTableProps> = ({ data, currentPage, itemsPerPage, params, setter, orderSetter, deleteHook}):JSX.Element => {
    const [alertState, setAlertState] = useState<boolean>(false)
    const [organization, setOrganization] = useState<OrgDeleteProps | undefined>(undefined)

    return (
        <BoxWrapper p="p0" bg="bg-primary" className="x-scroll relative" r="r15">
            <Table className="show-up-quick">
                <Head>
                    <Row>
                        <Th className="col-100"><></></Th>
                        <Th className="align-center table-align-left" style={{width:"100%"}}>
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Название
                                <OrderController 
                                    order={params.ordering} 
                                    value={'organization_name'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-250">
                            <BoxWrapper className="flex align-center space-between" p="p0" style={{paddingRight: "5px"}}>
                                Адрес
                                <OrderController 
                                    order={params.ordering} 
                                    value={'address'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-200">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Телефон
                                <OrderController 
                                    order={params.ordering} 
                                    value={'phone'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-200">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Почта
                                <OrderController 
                                    order={params.ordering} 
                                    value={'email'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="col-100"><></>
                        </Th>
                    </Row>
                </Head>
                <Body className="show-up-quick">
                    { data?.results && (data.results.map((item, index) => (
                            <Row key={index}  className="">
                                <Td className="table-align-left">
                                    <BoxWrapper>
                                        <div className="profile-avatar">
                                            { item.organization_image === null ? (
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 14C14.7614 14 17 11.7614 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14ZM12 14C7.58172 14 4 16.6863 4 20M12 14C16.4183 14 20 16.6863 20 20" stroke="#111111" strokeWidth="2" stroke-linecap="round"/>
                                                </svg>   
                                            ) : (
                                                <img className="profile-img" src={item.organization_image} alt="" />
                                            ) }
                                        </div>
                                    </BoxWrapper>
                                </Td>
                                <Td>
                                    <BoxWrapper className="table-align-left">
                                        <DetailText href={`/react/organization/${item.id}/details`} className="underline">{item.organization_name}</DetailText>
                                    </BoxWrapper>
                                </Td>
                                <Td>
                                    <BoxWrapper className="table-align-left">
                                        <Text>{item.address}</Text>
                                    </BoxWrapper>
                                </Td>
                                <Td>
                                    <BoxWrapper className="table-align-left">
                                        <Text>{item.email}</Text>
                                    </BoxWrapper>
                                </Td>
                                <Td>
                                    <BoxWrapper className="table-align-left">
                                        <Text>{item.phone}</Text>
                                    </BoxWrapper>
                                </Td>
                                <Td>
                                    <svg onClick={(e:any) => {
                                            setOrganization({
                                                id: item.id,
                                                organization_name: item.organization_name
                                            })
                                            setAlertState(true)

                                        }
                                    } width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" style={{cursor: "pointer"}}>
                                        <path d="M18.5617 24.8792V18.2754C18.5617 17.6432 19.0954 17.1311 19.7544 17.1311C20.4135 17.1311 20.9472 17.6432 20.9472 18.2754V24.8792C20.9472 25.5114 20.4135 26.0234 19.7544 26.0234C19.0954 26.0234 18.5617 25.5114 18.5617 24.8792ZM13.394 26.0234C14.0531 26.0234 14.5868 25.5114 14.5868 24.8792V18.2754C14.5868 17.6432 14.0531 17.1311 13.394 17.1311C12.735 17.1311 12.2013 17.6432 12.2013 18.2754V24.8792C12.2013 25.5114 12.735 26.0234 13.394 26.0234ZM28.9 11.41C28.9 12.5971 28.2663 13.6455 27.3091 14.262V26.4054C27.3091 28.7196 25.3485 30.6004 22.9362 30.6004H10.2138C7.80147 30.6004 5.84086 28.7196 5.84086 26.4054V14.262C4.88367 13.6455 4.25 12.5971 4.25 11.41C4.25 9.51629 5.85426 7.97731 7.8283 7.97731H10.6119V7.59541C10.6119 5.28121 12.5725 3.40039 14.9849 3.40039H18.1651C20.5775 3.40039 22.5381 5.28121 22.5381 7.59541V7.97731H25.3217C27.2957 7.97731 28.9 9.51629 28.9 11.41ZM12.9959 7.97731H20.1525V7.59541C20.1525 6.54415 19.261 5.68885 18.1651 5.68885H14.9849C13.889 5.68885 12.9975 6.54415 12.9975 7.59541V7.97731H12.9959ZM24.9236 14.8427H8.22487V26.4053C8.22487 27.4566 9.11645 28.3119 10.2123 28.3119H22.9346C24.0305 28.3119 24.9221 27.4566 24.9221 26.4053V14.8427H24.9236ZM26.5145 11.41C26.5145 10.7778 25.9807 10.2658 25.3217 10.2658H7.82677C7.16776 10.2658 6.63401 10.7778 6.63401 11.41C6.63401 12.0422 7.16776 12.5542 7.82677 12.5542H25.3202C25.9792 12.5542 26.5129 12.0422 26.5129 11.41H26.5145Z" fill="#A8A8A8"/>
                                    </svg>
                                </Td>
                            </Row>
                        )))
                    }
                </Body>
            </Table>
            {!data?.results && (
                <BoxWrapper style={{height: '250px'}}>
                    <Loader /> 
                </BoxWrapper>
            )}
            { data?.results?.length === 0 && <NoDataComponent/> }
            <Paginator
                key={data?.results ? data.results.length + 1 : 0}
                itemsPerPage={itemsPerPage} 
                totalItems={data ? data.count : 1} 
                currentPage={currentPage} 
                setPage={setter}/>
            { organization &&
                (
                <Alert alertState={alertState} alertHandler={setAlertState} alertTitle='Удалить организацию'>
                    <Text>Вы уверенны что готовы Удалить Организацию?</Text>
                    <br />
                    <FlexWrapper justifyContent='space-between'>
                        <button 
                            type="submit"
                            style={{position:'relative', height: '36px', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                            onClick={
                                (e:any) => {
                                    AxiosDeleteOrganization(organization.id, (value: RestApiState) => {deleteHook(value)})
                                    setAlertState(false)
                                }
                            }
                            className="bg-danger bold pointer"
                            >
                            Удалить {organization.organization_name}
                        </button>
                        <button 
                            type="submit"
                            style={{position:'relative', height: '36px', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                            onClick={(e) => setAlertState(false)}
                            className="pointer"
                            >
                            Нет
                        </button>
                    </FlexWrapper>
                </Alert>
                )
            }
            
        </BoxWrapper>
    )
}
